import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Tag } from 'app/types/tag.types';
import { TrinityService } from 'app/services/trinity/trinity.service';
import { Paginated } from 'app/types/pagination.types';

@Injectable({
  providedIn: 'root',
})
export class TagService {
  private readonly endpoint: string = '/tag';
  private defaultLimit: number = 100;

  constructor(private trinityService: TrinityService) {}

  get(): Observable<Tag[]> {
    const res = this.trinityService
      .get<
        Paginated<Tag>
      >(`${this.endpoint}`, { authorized: true, params: { limit: this.defaultLimit } })
      .pipe(map((value) => value.items));

    return res;
  }

  create(label: string): Observable<Tag> {
    const res = this.trinityService.post<Tag>(`${this.endpoint}`, {
      body: { label },
      authorized: true,
    });

    return res;
  }
}
